import {
  useDataSubmit,
  useDataIsSubmitting,
  useDataValue,
} from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'payers',
    viewPath: props.viewPath,
  })

  return async function (value) {
    submit({
      type: 'downpayment',
    })
  }
}

export function useIsDisabled(props) {
  let payment_method_type = useDataValue({
    context: 'payers',
    path: 'activeTab.downpayment_metadata.type',
    viewPath: props.viewPath,
  })
  let payment = useDataValue({
    context: 'payment',
    viewPath: props.viewPath,
  })
  let isSubmitting = useDataIsSubmitting({
    context: 'payers',
    viewPath: props.viewPath,
  })

  return (
    isSubmitting ||
    (['ach', 'card'].includes(payment_method_type) &&
      (!payment.valid ||
        (payment.is_fee_applicable && !payment.is_fee_acknowledged)))
  )
}
